import { IUserBalance, IUser } from '@shared/models';

export interface State {
  info: {
    loading: boolean;
    data: IUser;
    error: string;
  };
  balance: {
    loading: boolean;
    data: IUserBalance;
    error: string;
  };
  mfa: {
    mfaId: string;
    mfaContact: string;
    mfaBySms: boolean;
  };
}

export const initialState: State = {
  info: {
    loading: false,
    data: null,
    error: null
  },
  balance: {
    loading: false,
    data: {
      blocks: 0,
      certificates: 0,
      value: 0,
      soldCertificates: 0,
      soldCertificatesValue: 0,
      inTradeCertificates: 0,
      inTradeCertificatesValue: 0
    },
    error: null
  },
  mfa: {
    mfaId: null,
    mfaContact: null,
    mfaBySms: false
  }
};
